// Theme initialization - sets CSS custom properties from environment configuration
// Colors can be configured via Terraform (production) or .env files (development)

const DEFAULT_COLORS = {
  primary: '#2C3E50',
  primaryHover: '#1E3A5F',
  background: '#FDF8F9',
  text: '#3D4F5F',
};

export function initializeTheme() {
  const root = document.documentElement;

  // Helper to get color from window.env (production) or process.env (development)
  const getColor = (envKey, defaultValue) => {
    return window.env?.[envKey] || process.env[envKey] || defaultValue;
  };

  const colors = {
    '--color-primary': getColor('REACT_APP_THEME_PRIMARY', DEFAULT_COLORS.primary),
    '--color-primary-hover': getColor('REACT_APP_THEME_PRIMARY_HOVER', DEFAULT_COLORS.primaryHover),
    '--color-background': getColor('REACT_APP_THEME_BACKGROUND', DEFAULT_COLORS.background),
    '--color-text': getColor('REACT_APP_THEME_TEXT', DEFAULT_COLORS.text),
  };

  // Apply CSS custom properties to :root
  Object.entries(colors).forEach(([property, value]) => {
    root.style.setProperty(property, value);
  });
}
